var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.wappShow)?_c('div',{class:_vm.listDataBorder ? '' : 'list-border-no',attrs:{"id":"wapp"}},[_c('router-view'),_c('Watermark'),_c('DefaultDialog'),(_vm.isLocked)?_c('LockScreen'):_vm._e(),_c('CCUiStyleSetting')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }